import axios from "axios";
import Config from "../config"
export default class LoginService {
  login(username, password) {
    const options = {
    };
    let bodyTosend = {
      "username": username,
      "password": password,

    }
    return axios
      .post(
        Config.url("login"),
        bodyTosend,
        options
      )
      .then(res => res)
      // .catch(err => err)
  }

  firstAccess(username, newPassword, session) {
    const options = {};
    let bodyTosend = {
      "username": username,
      "newPassword": newPassword,
      "session": session
    }

    return axios
      .post(
        Config.proxy + Config.url("first_access"),
        bodyTosend,
        options
      )
      .then(res => res)
      .catch(err => err)
  }
  async refresh(refreshToken) {
    const options = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return await axios
      .post(
        Config.url("refresh_token"),
        {
          "refreshToken": refreshToken
        },
        options
      )
      .then(res => res.data);
  }
  logout(access_token) {
    const options = {
      headers: {
        ...Config.headers(access_token), ...{}
      }
    };
    return axios
      .post(
        Config.url("logout"),
        {},
        options
      )
      .then(res => res.data);
  }
  async abac(access_token) {
    const options = {
      headers: {
        ...Config.headers(access_token), ...{}
      }
    };

    return await axios
      .get(
        Config.url("abac"),
        options
      ).then(res => {
        // res.data.tenants = ['smegcons']; XXX_TENANT_XXX
        // console.log("abac", res.data);
        return res.data
      });
  }
  async abacOnTenant(access_token, tenant) {
    const options = {
      headers: {
        ...Config.headers(access_token), ...{}
      }
    };

    return await axios
      .get(
        Config.urlOnTenant("abac", tenant),
        options
      ).then(res => {
        // res.data.tenants = ['smegcons']; XXX_TENANT_XXX
        // console.log("abac", res.data);
        return res.data
      });
  }
  async fetchPersonalInfo(id = null, access_token) {
    const options = {
      headers: {
        ...Config.headers(access_token), ...{}
      }
    };
    return await axios
      .get(
        Config.url("personalInfo").replace("{{userCode}}", id),
        options
      )
      .then(res => res.data);
  }
}
